import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  API_URL_APPLICATIONS_FILES,
  SUBCOMMITTEE,
  SUBCOMMITTEE_DETAIL,
  SUBCOMMITTEE_UPDATE,
  API_URL_MY_SUBCOMMITTEE,
} from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {
  CONSTANT,
  FILE_EXTENSION,
  IMAGE_EXTENSION,
  LOADING_KEY,
  NUMBER,
} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-e204',
  templateUrl: './e204.component.html',
  styleUrls: ['./e204.component.scss', '../platform.component.scss'],
})

/**
 * 分科会申請登録(E204)
 * 分科会申請登録確認(E205)
 */
export class E204Component extends PlatformComponent {
  // 画面.入力フォーム
  e204InputForm: FormGroup = this.formBuilder.group({
    // 申請区分
    appli_kbn: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'appli_kbn',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 継続分科会
    continuation_id: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'continuation_id',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
    // 継続分科会テーマ
    continuation_theme: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      // asyncValidators: [
      //   this.validator.CheckValidator(
      //     'subcommittee',
      //     'continuation_theme',
      //     INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
      //   ),
      // ],
    }),
    // 提案テーマ
    theme: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'theme',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 分科会の目的
    purpose: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'purpose',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 解決したい課題
    agenda: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'agenda',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 活動概要
    outline: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'outline',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 活動内容１
    note1: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'note1',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 活動内容２
    note2: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'note2',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 活動内容３
    note3: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'note3',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 期待される成果
    outcome: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'outcome',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 資金・物資計画
    funding_plan: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'funding_plan',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 関連するゴール
    sdgs_goal: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'sdgs_goal',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 計画書概要（ファイルダウンロード）
    image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'image',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 参加してほしいメンバー
    members_who_want: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'members_who_want',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 想定しているメンバー数
    members_count: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'members_count',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // メンバーへの期待
    members_expectation: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'members_expectation',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 実施スケジュール
    schedule: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'schedule',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // その他特記事項
    note: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'note',
          INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
        ),
      ],
    }),
    // 主催（団体名称）
    organizer_group_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'organizer_group_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 主催（部署名）
    organizer_divition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'organizer_divition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 主催（担当者名）
    organizer_person_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'organizer_person_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 主催（電話番号）
    organizer_tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'organizer_tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 主催（eメールアドレス）
    organizer_email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'organizer_email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 窓口（団体名称）
    reception_group_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'reception_group_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 窓口（部署名）
    reception_divition_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'reception_divition_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 窓口（担当者名）
    reception_person_name: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'reception_person_name',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 窓口（電話番号）
    reception_tel: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'reception_tel',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // 窓口（eメールアドレス）
    reception_email: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'subcommittee',
          'reception_email',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
  });

  // 分科会IDを格納
  subcommitteeId: string = this.route.snapshot.queryParams.subcommittee_id;

  // 確認画面表示フラグ(true=分科会申請登録確認(E205),false=分科会申請登録(E204))
  confirmationFlag: boolean = false;

  // 計画書概要.ファイル名格納先
  fileName: string;

  // 自団体登録分科会
  organizerSubcommitteeList: object[] = new Array();

  // フォーム登録用
  sdgs_goal: object[] = new Array();

  applikbnDisabled: boolean = false;

  subcommitteeDisabled: boolean = false;

  // 個人情報の管理・運用チェック状態
  ruleCheckFlag: boolean[] = new Array();

  // 計画書概要存在フラグ
  image: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを分科会申請登録(E204)に変更する
    this.router.navigate(['pages/platform/e204/' + this.inputType], {
      queryParams: {
        screenId: 'e204',
        subcommittee_id: this.subcommitteeId,
      },
    });
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogin();

    // 辞書値リストを取得
    this.getSpecCodeList(3, 2025);

    // 新規初期表示
    this.seNewInitialData();

    // 自登録分科会取得
    this.getOrganizerSubcommittee();

    // 編集初期表示
    // this.setEditInitialData();
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });

  }

  /**
   * 新規初期表示
   */
  private seNewInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.NEW == this.inputType)) {
      // 新規以外の場合
      return;
    }

    // 初期値セット
    this.commonService.setFormGroupInitialData(this.e204InputForm, {
      organizer_group_name: this.loginUser.organization_name,
      organizer_divition_name: this.loginUser.division_name,
      organizer_person_name: this.loginUser.full_name,
      organizer_tel: this.loginUser.tel,
      organizer_email: this.loginUser.email,
    });

    // 申請区分,継続分科会を編集不可とする
    this.subcommitteeDisabled = true;
  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if (!(GENERATE_INPUT_TYPE.EDIT == this.inputType)) {
      // 編集以外の場合
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_DETAIL);

    // 分科会詳細を取得
    this.dbOperationService
      .getNoTemplateDisplayData(SUBCOMMITTEE_DETAIL, this.subcommitteeId, true)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_DETAIL);
        if (this.commonService.checkNoneResponse(response)) {
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if(!this.decisionPerspective(response.body.member_id)
          && !this.decisionSecretariat()
        ){
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.e204InputForm,
          response.body
        );

        // 継続の場合
        // if ("1" == this.e204InputForm.get('appli_kbn').value.toString()) {
        //   // 継続分科会をセットする
        //   this.organizerSubcommitteeList.forEach((subcommittee) => {
        //     if (subcommittee['subcommittee_id'].toString() == this.e204InputForm.get('continuation_id').value.toString()) {
        //       this.e204InputForm.get('continuation_id').setValue(subcommittee['subcommittee_id']);
        //     }
        //   });
        // } else {
        //   this.e204InputForm.get('continuation_id').disable();
        // }

        // 申請区分,継続分科会を編集不可とする
        this.applikbnDisabled = true;
        this.subcommitteeDisabled = true;
        // 計画書概要存在フラグ
        {
          if (response.body.image.id != CONSTANT.EMPTY_STRING && response.body.image.id?.length != 0) this.image = true;
        }
        this.fileName = response.body.image.name;

      });
  }

  /**
   * ファイルアップロード
   * @param event ファイル情報
   * @param fileUpload ボタン動作状態
   */
  public uploadFile(event: any, fileUpload: any) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_APPLICATIONS_FILES);

    // ファイル情報からファイル名を取得
    const fileName = event.files[0].name;

    // 拡張子を取得
    const extension = event.files[0].name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );

    // 拡張子が".pdf" or ".PDF"か否か判定
    if (
      !(FILE_EXTENSION.PDF == extension || FILE_EXTENSION.PDF2 == extension)
    ) {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 拡張子が".pdf" or ".PDF"以外の場合

      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(MESSAGE_CODE.E00013, 'pdf又はPDF'),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイルサイズの判定
    if (NUMBER.ZERO == event.files[0].size || 10485760 <= event.files[0].size) {

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // ファイルサイズが0KBの場合 または
      // 10MB以上の場合

      // 画像サイズエラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(MESSAGE_CODE.E00025, '1KB以上、10MB以下'),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイル情報(base64)取得処理
    this.commonService.getBase64(event.files[0]).then((b64: string) => {
      const csize = 5000000;   //5MBで分割
      var lc = (Math.floor(b64.length / csize) + 1)  //全ループ回数＝分割数
      var s: number;
      var e: number;
      var b64_konkai: string;    //ループ毎に処理するbase64エンコード
      var b64_arr = new Array   //バッファ

      //先頭部分の除去
      b64 = b64.replace(/^data:.*?;base64,/, '');

      for (var c = 0; c < lc; c++) {
        //開始Indexと終了Index
        s = c * csize
        e = (s + csize);
        if (e >= b64.length) {
          e = b64.length;
        }

        //バッファ配列にセット
        b64_konkai = b64.substring(s, e);
        b64_arr.push(b64_konkai)
      }

      // ファイル登録を実施 処理部分
      const file_register = (b64_arr: Array<any>, lc: number) => {
        return new Promise(resolve => {
          this.dbOperationService
            .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[0], 1, lc)
            .subscribe((response) => {
              // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
              this.e204InputForm.get('image').markAsDirty();

              // 画面.入力フォームにファイルIDを格納
              this.e204InputForm.get('image').setValue(response.body.file_id);

              // ファイル名を格納
              this.fileName = fileName;

              //分割2回目～
              if (lc >= 2) {
                var arr = new Array;
                for (var c = 2; c <= lc; c++) {
                  arr.push(c);
                }
                (async () => {
                  for await (var num of arr) {
                    const res = await file2_register(num);
                  }
                  resolve("ok");
                })();
              } else resolve("ok");

              const file2_register = (n: number) => {
                return new Promise(resolve2 => {
                  this.dbOperationService
                    .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[n - 1], n, lc)
                    .subscribe((response) => {
                      resolve2(response.body);
                    });
                })
              }
            });
        })
      }

      // ファイル登録を実施
      (async () => {
        const f_s = await file_register(b64_arr, lc);
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      })();
    });

    // 初期画像表示ID削除
    this.breakImgCaptionFlg();
  }

  /**
   * アップロードファイル削除
   */
  public deleteFile() {
    // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
    this.e204InputForm.get('image').markAsDirty();

    // 画面.入力フォームからファイル情報を削除
    this.e204InputForm.get('image').setValue(CONSTANT.EMPTY_STRING);

    // ファイル名を格納
    this.fileName = CONSTANT.EMPTY_STRING;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg();
  }

  /**
   * 分科会申請登録(E204)を表示する
   */
  public moveE204(): void {
    // 分科会申請登録(E204)へ遷移
    this.router.navigate(
      ['pages/platform/e204/' + this.route.snapshot.params.inputType],
      {
        queryParams: {
          screenId: 'e204',
          subcommittee_id: this.subcommitteeId,
        },
      }
    );

    // 分科会申請登録(E204)を表示する
    this.confirmationFlag = false;

    let e204InputForm: any = JSON.parse(
      JSON.stringify(this.e204InputForm.value)
    );
    {
      if (e204InputForm.image.id != CONSTANT.EMPTY_STRING && e204InputForm.image.id?.length != 0) this.image = true;
    }
    const fileName = e204InputForm.image.name;
  }

  /**
   * 分科会申請登録確認(E205)を表示する
   */
  public moveE205(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let e204InputForm: any = JSON.parse(
      JSON.stringify(this.e204InputForm.value)
    );

    // 関連するゴールをカンマ区切り変換
    e204InputForm.sdgs_goal = e204InputForm.sdgs_goal.toString();

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'subcommittee',
        e204InputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 分科会申請登録確認(E205)へ遷移
      this.router.navigate(
        ['pages/platform/e204/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'e205',
            subcommittee_id: this.subcommitteeId,
          },
        }
      );

      // 分科会申請登録確認(E205)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 分科会申請登録完了(E206)へ遷移する
   */
  public moveE206(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let e204InputForm: any = JSON.parse(
      JSON.stringify(this.e204InputForm.value)
    );

    // 関連するゴールをカンマ区切り変換
    e204InputForm.sdgs_goal = e204InputForm.sdgs_goal.toString();

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 会員ID
      e204InputForm.member_id = this.getLoginMemberId();

      // 分科会申請登録を実施
      this.dbOperationService
        .insertData(SUBCOMMITTEE, e204InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 分科会申請登録完了(E206)へ遷移
            this.router.navigate(['pages/platform/e206']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 分科会申請登録(E204)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合
      // 会員ID
      e204InputForm.member_id = this.getLoginMemberId();

      // 分科会ID
      e204InputForm.subcommitteeId = this.subcommitteeId;

      // 分科会申請更新を実施
      this.dbOperationService
        .updateData(SUBCOMMITTEE_UPDATE, this.subcommitteeId, e204InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合

            // 分科会申請登録完了(E206)へ遷移
            this.router.navigate(['pages/platform/e206']);
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E80002),
              })
            );

            // 分科会申請登録(E204)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * 自団体登録分科会を取得
   */
  private getOrganizerSubcommittee() {

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_MY_SUBCOMMITTEE);

    // 会員主催イベント申請詳細を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_MY_SUBCOMMITTEE, { member_id: this.loginUser.member_id }, false)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          this.organizerSubcommitteeList = new Array();
          this.setEditInitialData();
        } else {
          this.organizerSubcommitteeList = response.body;
          this.setEditInitialData();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_MY_SUBCOMMITTEE);
      });
  }

  /**
   * 継続区分選択時の変動フォーム設定
   * @param appli_kbn
   */
  public formChange(appli_kbn: string) {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let e204InputForm: any = JSON.parse(
      JSON.stringify(this.e204InputForm.value)
    );

    // 変動フォームコントロールを設定
    // 新規
    if ("0" == e204InputForm.appli_kbn) {
      // 以下項目を活性/非活性
      this.e204InputForm.get('theme').enable();
      this.e204InputForm.get('continuation_id').disable();
      // 以下項目の値を削除(初期設定で設定される主催(xxx)情報を除く)
      this.e204InputForm.get('continuation_id').setValue(null);
      this.e204InputForm.get('theme').setValue(null);
      this.e204InputForm.get('purpose').setValue(null);
      this.e204InputForm.get('agenda').setValue(null);
      this.e204InputForm.get('outline').setValue(null);
      this.e204InputForm.get('note1').setValue(null);
      this.e204InputForm.get('note2').setValue(null);
      this.e204InputForm.get('note3').setValue(null);
      this.e204InputForm.get('outcome').setValue(null);
      this.e204InputForm.get('funding_plan').setValue(null);
      this.e204InputForm.get('sdgs_goal').setValue(null);
      this.e204InputForm.get('image').setValue(null);
      this.e204InputForm.get('members_who_want').setValue(null);
      this.e204InputForm.get('members_count').setValue(null);
      this.e204InputForm.get('members_expectation').setValue(null);
      this.e204InputForm.get('schedule').setValue(null);
      this.e204InputForm.get('note').setValue(null);
      this.e204InputForm.get('reception_group_name').setValue(null);
      this.e204InputForm.get('reception_divition_name').setValue(null);
      this.e204InputForm.get('reception_person_name').setValue(null);
      this.e204InputForm.get('reception_tel').setValue(null);
      this.e204InputForm.get('reception_email').setValue(null);
      // 初期値セット
      this.commonService.setFormGroupInitialData(this.e204InputForm, {
        organizer_group_name: this.loginUser.organization_name,
        organizer_divition_name: this.loginUser.division_name,
        organizer_person_name: this.loginUser.full_name,
        organizer_tel: this.loginUser.tel,
        organizer_email: this.loginUser.email,
      });
    } else if ("1" == e204InputForm.appli_kbn) {
      this.e204InputForm.get('continuation_id').enable();
      this.e204InputForm.get('continuation_id').setValue(null);
      this.e204InputForm.get('theme').setValue(null);
    }

    // 継続分科会必須チェックを実施
    this.checkRequired();
  }

  /**
   * 継続分科会選択時の変動フォーム設定
   */
  public viewChange() {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let e204InputForm: any = JSON.parse(
      JSON.stringify(this.e204InputForm.value)
    );

    // 変動フォームコントロールを設定
    // 以下項目を非活性
    // 以下項目の値を設定(初期設定で設定される主催(xxx)情報を除く)
    this.organizerSubcommitteeList.forEach((subcommittee) => {
      if(subcommittee['subcommittee_id'] == this.e204InputForm.get("continuation_id").value){
        this.e204InputForm.get('theme').setValue(subcommittee['theme']);
        this.e204InputForm.get('purpose').setValue(subcommittee['purpose']);
        this.e204InputForm.get('agenda').setValue(subcommittee['agenda']);
        this.e204InputForm.get('outline').setValue(subcommittee['outline']);
        this.e204InputForm.get('note1').setValue(null);
        this.e204InputForm.get('note2').setValue(null);
        this.e204InputForm.get('note3').setValue(null);
        this.e204InputForm.get('outcome').setValue(subcommittee['outcome']);
        this.e204InputForm.get('funding_plan').setValue(subcommittee['funding_plan']);
        this.sdgs_goal = new Array();
        for (const goal of subcommittee['sdgs_goal']) {
          this.sdgs_goal.push(goal['id'].toString());
        }
        this.e204InputForm.get('sdgs_goal').setValue(this.sdgs_goal);
        this.e204InputForm.get('image').setValue(null);
        this.e204InputForm.get('members_who_want').setValue(subcommittee['members_who_want']);
        this.e204InputForm.get('members_count').setValue(subcommittee['members_count']);
        this.e204InputForm.get('members_expectation').setValue(subcommittee['members_expectation']);
        this.e204InputForm.get('schedule').setValue(null);
        this.e204InputForm.get('note').setValue(subcommittee['note']);
        this.e204InputForm.get('organizer_group_name').setValue(subcommittee['organizer_group_name']);
        this.e204InputForm.get('organizer_divition_name').setValue(subcommittee['organizer_divition_name']);
        this.e204InputForm.get('organizer_person_name').setValue(subcommittee['organizer_person_name']);
        this.e204InputForm.get('organizer_tel').setValue(subcommittee['organizer_tel']);
        this.e204InputForm.get('organizer_email').setValue(subcommittee['organizer_email']);
        this.e204InputForm.get('reception_group_name').setValue(subcommittee['reception_group_name']);
        this.e204InputForm.get('reception_divition_name').setValue(subcommittee['reception_divition_name']);
        this.e204InputForm.get('reception_person_name').setValue(subcommittee['reception_person_name']);
        this.e204InputForm.get('reception_tel').setValue(subcommittee['reception_tel']);
        this.e204InputForm.get('reception_email').setValue(subcommittee['reception_email']);
      }
    });

    // 継続分科会必須チェックを実施
    this.checkRequired();
  }

  /**
   * 継続分科会必須入力判定
   * @param formName フォーム項目名
   */
  public checkRequired() {
    // 申請区分、継続分科会を取得
    let appli_kbn = this.e204InputForm.get("appli_kbn").value;
    let continuation_id = this.e204InputForm.get("continuation_id").value;
    // 申請区分が継続の場合
    if ("1" == appli_kbn) {
      // 継続分科会が入力済みか判定
      if ((continuation_id == null || continuation_id.length == 0 || continuation_id == CONSTANT.EMPTY_STRING)) {
        // 未入力の場合

        // メッセージを表示させるために対象項目をマーク
        this.e204InputForm.controls["continuation_id"].markAsDirty();
        // エラーメッセージ設定
        this.e204InputForm.controls["continuation_id"].setErrors({
          message: '必須項目です。必ず入力してください。',
        });
      }
      // 継続以外
    } else if ("1" != appli_kbn) {
      // 継続分科会を編集不可能項目に設定
      this.subcommitteeDisabled = true;

    }
  }

  /**
   * 初期画像IDフラグの削除
   * @param formName フォーム項目名
   */
  public breakImgCaptionFlg(): void {
    // フラグを折る
    this.image = false;
  }
}
